const dataInsertedHooks = [];

/**
 * Add a callback to the hook list
 * @param {Array} list - The list of registered callbacks
 * @param {Function} fn - The callback to be added
 * @return {Function} A method to unregister the function from the list
 */
function registerHook(list, fn) {
    list.push(fn);

    return () => {
        const i = list.indexOf(fn);
        if (i > -1) {
            list.splice(i, 1);
        }
    };
}

/**
 * The interface method to register a `dataInserted` hook method
 * @param {Function} fn - The callback to be added
 * @return {Function} A method to unregister the function
 */
export function dataInserted(fn) {
    return registerHook(dataInsertedHooks, fn);
}

/**
 * Trigger the `dataInserted` hook
 */
export function triggerDataInserted() {
    dataInsertedHooks.forEach(fn => fn());
}
